export default __webpack_public_path__ + "static/media/bg-pattern.7fe8c943.svg";